import React, { FunctionComponent } from 'react';
import {
  CardListItem,
  CardListItemProps
} from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { CardListItemTitle } from 'record-it-components/cardList/CardListItemTitle/CardListItemTitle';
import { useModalOpened } from 'record-it-components/hooks/useModalOpened/useModalOpened';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { User } from '../../../classes/entities/User/userTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { useUserDeleteHandler } from '../../../hooks/entity/deleteHandler/useUserDeleteHandler';
import { EditUserDialog } from '../EditUserDialog/EditUserDialog';

export type UserListItemProps = PropsWithoutChildren<CardListItemProps> & {
  user: User;
};

export const UserListItem: FunctionComponent<UserListItemProps> = React.memo(
  (props) => {
    const { user, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    const {
      open: openEditUserDialog,
      close: closeEditUserDialog,
      modalProps
    } = useModalOpened({ closeOnBackDropClick: true });

    const handleDeleteClick = useUserDeleteHandler(user);

    return (
      <>
        <CardListItem {...remainingProps}>
          <CardListItemTitle>{user.email}</CardListItemTitle>
          <CardListItemIconButton
            {...iconConfigurations.prefixed.listItem.deleteIcon}
            onClick={handleDeleteClick}
            data-testid="UserListItem.DeleteButton"
          ></CardListItemIconButton>
          <CardListItemIconButton
            {...iconConfigurations.prefixed.listItem.editInDialogIcon}
            onClick={openEditUserDialog}
          ></CardListItemIconButton>
        </CardListItem>
        <EditUserDialog
          {...modalProps}
          user={user}
          onAccept={closeEditUserDialog}
        ></EditUserDialog>
      </>
    );
  }
);
